import {z} from "zod"
import {Frequency, frequencySchema} from "@indebted/payment-arrangement/Slider/Frequency"
import {format} from "date-fns"

import {getJson} from "../http"

const RepaymentSchema = z.strictObject({
	PaymentDate: z.coerce.date(),
	PaymentAmount: z.number(),
})

export type Repayment = z.infer<typeof RepaymentSchema>

const PaymentArrangementSetupSchema = z.strictObject({
	Currency: z.string(),
	PaymentAmount: z.number(),
	Frequency: frequencySchema,
	NumberOfPayments: z.number(),
	StartDate: z.coerce.date(),
	EndDate: z.coerce.date(),
	Payments: z.array(RepaymentSchema),
})

export type PaymentArrangementSetup = z.infer<typeof PaymentArrangementSetupSchema>

export async function getSetupPage({
	paymentArrangementID,
	frequency,
	numberOfPayments,
	startDate,
}: {
	paymentArrangementID: string
	frequency: Frequency
	numberOfPayments: number
	startDate: Date
}): Promise<PaymentArrangementSetup> {
	const data = await getJson(
		`/app/payment-arrangements/${paymentArrangementID}/setup?` +
			new URLSearchParams({
				Frequency: frequency,
				NumberOfPayments: numberOfPayments.toString(),
				StartDate: format(startDate, "yyyy-MM-dd"),
			}).toString(),
		PaymentArrangementSetupSchema,
	)
	return data
}
